<div class="ws-flex-container-horizontal ws-flex-align-items-center">
    <select name="limitOptions"
            id="limitOptions"
            class="form-select form-select-sm asset-limit-dropdown"
            [formControl]="selectedOption"
            (change)="selectedOptionChanged()">
        @for (li of limitOptions; track li) {
            <option [ngValue]="li">{{ li.name }}</option>
        }
    </select>
    <button type="button"
            class="ace-btn btn-sm btn-primary has-icon"
            (click)="edit()"
            helpTooltip
            helpContentId="app.edit"
            position="bottom">
        <i class="fa fa-pencil"></i>
    </button>
</div>
